import HeadingContainer from 'redux/containers/components/search/HeadingContainer'
import Results from 'components/search/Results'
import PaginationContainer from 'redux/containers/components/search/PaginationContainer'
import React, { useEffect, useRef } from 'react'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import { useSelector } from 'react-redux'
import selectPlaceholders from 'redux/selectors/selectPlaceholders'
import url from 'libraries/front-end-core/core/url'
import { SEARCH } from 'constants/controllers'
import { RelatedQaSection } from 'components/smartsearch/RelatedQaSection'

const PagedSearchResults = ({
  pageLimit,
  pageNumber,
  query,
  response,
  searchPhrase,
  searchType,
  flavour,
  setSearchResultsLoaded,
  setSearchResponse,
  isMobile,
  pageId,
  aol,
  vectorResults
}) => {
  useEffect(() => {
    setSearchResultsLoaded(true)
    return () => setSearchResultsLoaded(false)
  }, [])

  useEffect(() => {
    setSearchResponse(response)
  }, [response])

  if (response && typeof response.resultCount === 'number') {
    return response.resultCount > 0
      ? (
        <SearchList
          {...{
            pageLimit,
            pageNumber,
            query,
            response,
            searchPhrase,
            searchType,
            flavour,
            pageId,
            isMobile,
            aol,
            vectorResults
          }}
        />
        )
      : (
        <SearchEmpty {...{ response, searchPhrase }} />
        )
  }
  return null
}

export const searchTitles = (flavour) => ({
  legislation: 'Search results - Legislation',
  qa: `Search results - Q&A${flavour === 'archive' ? ' (archived)' : ''}`,
  documents: 'Search results - Documents',
  ca: 'Search results - News'
})

const SearchList = ({
  aol,
  pageLimit,
  pageNumber,
  query,
  response,
  searchPhrase,
  searchType,
  flavour,
  pageId,
  isMobile,
  vectorResults
}) => {
  const title = searchTitles(flavour)[searchType] || 'Search results'
  const { isSearchResultsLoaded } = useSelector(selectPlaceholders)
  const { facets = [], resultCount = 0, results = [] } = response || {}
  const resultsOnPage = results.length
  const caseSearch = query.boostCases === 'true'

  const resultsSectionRef = useRef()

  const getLink = (pageNumber) =>
    url(
      SEARCH,
      { aol, flavour, searchPhrase, searchType },
      { ...query, p: pageNumber }
    )

  useEffect(() => {
    isSearchResultsLoaded &&
      scrollTo({
        pageId,
        element: resultsSectionRef.current,
        useWindowScrollTo: isMobile
      })
  }, [pageNumber, resultsSectionRef, isSearchResultsLoaded])

  return (
    <section className='bg-page-background' ref={resultsSectionRef}>
      <div className='layout-width-constraint'>
        <div className='bb b--lite-grey mb7'>
          {vectorResults && !!vectorResults.length && (
            <RelatedQaSection {...{ aol, flavour, vectorResults, caseSearch }} />
          )}
          <HeadingContainer
            {...{
              resultsOnPage,
              facets,
              resultCount,
              pageLimit,
              pageNumber,
              query,
              searchPhrase,
              title
            }}
          />
          <Results {...{ results }} />
        </div>
        <PaginationContainer
          {...{
            resultsOnPage,
            resultCount,
            pageLimit,
            pageNumber,
            query,
            searchPhrase,
            getLink
          }}
        />
      </div>
    </section>
  )
}

const SearchEmpty = ({ response = {}, searchPhrase }) => (
  <section className='bg-page-background'>
    <div className='layout-width-constraint'>
      <HeadingContainer
        facets={response.facets}
        key='heading'
        searchPhrase={searchPhrase}
        title='Search returned no results'
        resultCount={0}
      />
    </div>
  </section>
)

export default PagedSearchResults
